// extracted by mini-css-extract-plugin
export default {"btn":"RaterBtn_btn__DeaPB","shake-animation":"RaterBtn_shake-animation__M563h","count":"RaterBtn_count__K6K+N"};